export enum VehicleType {
  Car = "car",
  Gwagon = "gwagon",
  Boxer = "boxer",
  Hawkei = "hawkei",
  BRDM = "BRDM",
}
